import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import TeamMenu from './teamMenu';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

const TopNav: React.FC<{ teamSelected: string | null }> = ({ teamSelected }) => {

    const location = useLocation();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
      };
    
      const handleClose = () => {
        setAnchorEl(null);
      };

    return (
        <div className="topnav">
            <div className="links">
                <a href="/">Home</a>                
            </div>
            <TeamMenu />
            {teamSelected &&  location.pathname.includes('/player') && (<div className='links'><Link to={`/team/${teamSelected}`} >back to Team</Link></div>)}
            <div className="links">
                <a href="/standings">Standings</a>                
            </div>
            <div className="links">
                <a href="/leaders">Leaders</a>                
            </div>


            {/* <AppBar position="static">
                <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2 }}
                        onClick={(event) => setAnchorEl(event.currentTarget)} // Open menu on click
                    >
                        <MenuIcon />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleClose}>Home</MenuItem>
                        <MenuItem onClick={handleClose}>Teams</MenuItem>
                        <MenuItem onClick={handleClose}>Standings</MenuItem>
                        <MenuItem onClick={handleClose}>Leaders</MenuItem>
                    </Menu>                
                </Toolbar>
            </AppBar> */}

        </div>
    );
}

export default TopNav;